module.exports = __webpack_public_path__ + "b251fff4d7fef5a3bdbe7183681e9205.png";


//////////////////
// WEBPACK FOOTER
// ./app/img/iconos/tuempresa.png
// module id = 2159
// module chunks = 0